var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatStrikethrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.0406V12.2324H16.4059C16.9968 13.5077 16.9673 16.9998 12.7245 16.9998C7.80227 17.0296 7.99136 13.1263 7.99136 13.1263L10.3373 13.1561C10.355 15.1644 12.2045 15.1644 12.5709 15.1405C12.9491 15.1107 14.3614 15.1167 14.4736 13.7222C14.5209 13.0727 13.8709 12.5781 13.1618 12.2324H6V11.0406H19ZM16.8786 8.59132L14.5268 8.57344C14.5268 8.57344 14.6273 6.92273 12.5886 6.91677C10.55 6.90485 10.7273 8.2278 10.7273 8.39466C10.7509 8.56152 10.9282 9.3839 12.5 9.77721H8.78318C8.78318 9.77721 6.72091 5.76663 11.7555 5.08132C16.9023 4.36621 16.8905 8.60324 16.8786 8.59132Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatStrikethrough);
export default __webpack_public_path__ + "static/media/FormatStrikethrough.62860cd560c637c1e92b2535b2b83413.svg";
export { ForwardRef as ReactComponent };